/* Team K9 About page runtime. Progressive: the page reads fine without it (see .tka-js in the CSS). */
(function () {
  "use strict";
  var root = document.querySelector("[data-tka]");
  if (!root) return;

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var fmt = new Intl.NumberFormat("en-US");
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  /* ---- count-ups ---- */
  function countUp(el) {
    if (el.__tkaDone) return;
    el.__tkaDone = true;
    var end = parseFloat(el.getAttribute("data-tka-count"));
    if (!isFinite(end)) return;
    if (reduceMotion) { el.textContent = fmt.format(end); return; }
    var start = performance.now(), dur = Math.min(1800, 700 + end / 4);
    (function tick(now) {
      var t = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = fmt.format(Math.round(end * eased));
      if (t < 1) requestAnimationFrame(tick);
    })(start);
  }

  /* ---- reveal on scroll ---- */
  var revealTargets = $$("[data-rv], [data-tka-steps], .tka-bars, [data-tka-print]");
  if ("IntersectionObserver" in window && !reduceMotion) {
    var rvIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-in");
        rvIO.unobserve(entry.target);
      });
    }, { rootMargin: "0px 0px 12% 0px", threshold: 0.01 });
    revealTargets.forEach(function (n) { rvIO.observe(n); });

    var countIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        countUp(entry.target);
        countIO.unobserve(entry.target);
      });
    }, { threshold: 0.4 });
    $$("[data-tka-count]").forEach(function (n) { countIO.observe(n); });
  } else {
    revealTargets.forEach(function (n) { n.classList.add("is-in"); });
  }

  /* ---- live numbers ----
     Verified buyers: the sitewide proof-stats script tag carries the current count.
     Reviews: total published product reviews from the Loox storefront API. */
  var proofTag = document.querySelector("script[data-customer-count]");
  var buyers = proofTag ? parseInt(String(proofTag.getAttribute("data-customer-count")).replace(/[^\d]/g, ""), 10) : 0;
  if (buyers > 1000) {
    $$("[data-tka-buyers]").forEach(function (n) {
      n.setAttribute("data-tka-count", String(buyers));
      if (n.__tkaDone || reduceMotion) n.textContent = fmt.format(buyers);
    });
    var rounded = fmt.format(Math.floor(buyers / 1000) * 1000);
    $$("[data-tka-buyers-round]").forEach(function (n) { n.textContent = rounded; });
  }
  var storeId = root.getAttribute("data-loox-store");
  if (storeId && window.fetch) {
    fetch("https://storefront-api.loox.io/storefront/v1/store/" + storeId + "/product-reviews?limit=1&page=1", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var total = j && j.pagination && Number(j.pagination.total);
        if (total > 1000) $$("[data-tka-reviews]").forEach(function (n) { n.textContent = fmt.format(total); });
      })
      .catch(function () {});
  }

  /* ---- marquees: duplicate the row so the -50% loop is seamless ---- */
  if (!reduceMotion) {
    $$("[data-tka-marquee]").forEach(function (track) {
      Array.prototype.slice.call(track.children).forEach(function (child) {
        var clone = child.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        track.appendChild(clone);
      });
    });
  }

  /* ---- customer clips: load when near, play while visible, tap to toggle ---- */
  var clips = $$("[data-tka-clip]");
  function setPoster(video) { if (!video.getAttribute("poster") && video.getAttribute("data-poster")) video.setAttribute("poster", video.getAttribute("data-poster")); }
  /* posters for the whole rail load together once the rail is within reach (off-screen cards in a swipe row
     never intersect on their own) */
  var clipRail = root.querySelector("[data-tka-clips]");
  if (clipRail && "IntersectionObserver" in window) {
    var posterIO = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      clips.forEach(setPoster);
      posterIO.disconnect();
    }, { rootMargin: "900px 0px" });
    posterIO.observe(clipRail);
  } else {
    clips.forEach(setPoster);
  }
  function load(video) {
    if (video.getAttribute("src")) return;
    var small = video.getAttribute("data-src-sm");
    var phone = window.matchMedia && window.matchMedia("(max-width: 749px)").matches;
    video.setAttribute("src", small && phone ? small : video.getAttribute("data-src"));
  }
  function setPlaying(video, on) {
    var card = video.closest(".tka-clip");
    if (on) {
      load(video);
      var p = video.play();
      if (p && p.then) p.then(function () { card.classList.add("is-playing"); }).catch(function () {});
    } else {
      video.pause();
      card.classList.remove("is-playing");
    }
  }
  var saveData = navigator.connection && (navigator.connection.saveData || /2g|3g/.test(navigator.connection.effectiveType || ""));
  if (clips.length && "IntersectionObserver" in window && !reduceMotion && !saveData) {
    var clipIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target.__tkaUserPaused) return;
        setPlaying(entry.target, entry.isIntersecting && entry.intersectionRatio > 0.6);
      });
    }, { threshold: [0, 0.6, 1] });
    clips.forEach(function (v) { clipIO.observe(v); });
  }
  clips.forEach(function (video) {
    video.closest(".tka-clip").addEventListener("click", function () {
      var playing = !video.paused && !video.ended;
      video.__tkaUserPaused = playing;
      setPlaying(video, !playing);
    });
  });

  /* ---- the film: loads when near, autoplays muted while in view, sound is opt-in ---- */
  var film = root.querySelector("[data-tka-film]");
  if (film) {
    var frame = film.closest("[data-tka-film-frame]");
    var toggle = root.querySelector("[data-tka-film-toggle]");
    var sound = root.querySelector("[data-tka-film-sound]");
    var soundLabel = root.querySelector("[data-tka-film-sound-label]");
    var filmUserPaused = false;
    var filmPlay = function () {
      load(film);
      var p = film.play();
      if (p && p.catch) p.catch(function () {});
    };
    film.addEventListener("play", function () { frame.classList.add("is-playing"); toggle.setAttribute("aria-label", "Pause the film"); });
    film.addEventListener("pause", function () { frame.classList.remove("is-playing"); toggle.setAttribute("aria-label", "Play the film"); });
    toggle.addEventListener("click", function () {
      if (film.paused) { filmUserPaused = false; filmPlay(); } else { filmUserPaused = true; film.pause(); }
    });
    sound.addEventListener("click", function () {
      var on = film.muted;
      film.muted = !on;
      sound.setAttribute("aria-pressed", on ? "true" : "false");
      soundLabel.textContent = on ? "Sound on" : "Tap for sound";
      if (on) { filmUserPaused = false; if (film.paused) filmPlay(); }
    });
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
          var storyPlaying = $$("[data-tka-vid] video").some(function (v) { return !v.paused; });
          if (!filmUserPaused && !reduceMotion && !saveData && !storyPlaying) filmPlay();
        } else if (!film.paused) {
          film.pause();
        }
      }, { threshold: [0, 0.5, 1] }).observe(film);
    }
  }

  /* ---- tap-to-play films (the story film in the founder's note): sound on, native controls, one film at a time ---- */
  $$("[data-tka-vid]").forEach(function (box) {
    var video = box.querySelector("video"), button = box.querySelector("[data-tka-vid-play]");
    if (!video || !button) return;
    button.addEventListener("click", function () {
      load(video);
      video.controls = true;
      box.classList.add("is-playing");
      if (film && !film.paused) film.pause();
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    });
    video.addEventListener("play", function () { if (film && !film.paused) film.pause(); });
  });

  /* ---- the ledger: tap a delivery on the receipt to see what was in it ---- */
  var deliveries = root.querySelector("[data-tka-deliveries]");
  var barList = root.querySelector("[data-tka-bars]");
  if (deliveries && barList) {
    var receipt = deliveries.closest(".tka-receipt");
    var ledgerButtons = $$("button[data-d]", receipt);
    var ledgerLabel = root.querySelector("[data-tka-ledger-label]");
    var hint = root.querySelector("[data-tka-ledger-hint]");
    var rows = $$("li[data-q]", barList);
    var sizes = $$("[data-tka-sizes] li[data-q]");
    if (hint) hint.hidden = false;
    var setNumber = function (el, value) {
      el.__tkaDone = true;
      el.setAttribute("data-tka-count", String(value));
      el.textContent = fmt.format(value);
    };
    var showDelivery = function (index, label) {
      var values = rows.map(function (li) { return Number(li.getAttribute("data-q").split(",")[index]); });
      var max = Math.max.apply(null, values) || 1;
      rows.forEach(function (li, i) {
        li.style.setProperty("--w", (values[i] ? Math.max(3, Math.round(values[i] / max * 100)) : 0) + "%");
        li.classList.toggle("is-zero", values[i] === 0);
        setNumber(li.querySelector(".tka-bar-n"), values[i]);
      });
      sizes.forEach(function (li) {
        var v = Number(li.getAttribute("data-q").split(",")[index]);
        li.classList.toggle("is-zero", v === 0);
        li.querySelector("b").textContent = fmt.format(v);
      });
      if (ledgerLabel) ledgerLabel.textContent = label;
      ledgerButtons.forEach(function (b) { b.setAttribute("aria-pressed", Number(b.getAttribute("data-d")) === index ? "true" : "false"); });
    };
    ledgerButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        showDelivery(Number(button.getAttribute("data-d")), button.getAttribute("data-label"));
      });
    });
  }

  /* ---- sticky bar on phones: after the hero, hidden again at the closing section ---- */
  var sticky = root.querySelector("[data-tka-sticky]");
  var hero = root.querySelector(".tka-hero");
  var closer = root.querySelector(".tka-closer");
  if (sticky && hero && "IntersectionObserver" in window) {
    sticky.hidden = false;
    var heroOut = false, closerIn = false;
    function sync() { sticky.classList.toggle("is-on", heroOut && !closerIn); }
    new IntersectionObserver(function (e) { heroOut = !e[0].isIntersecting; sync(); }, { threshold: 0 }).observe(hero);
    /* stays hidden once the closing section has been reached, including the footer below it */
    if (closer) new IntersectionObserver(function (e) { closerIn = e[0].isIntersecting || e[0].boundingClientRect.top < 0; sync(); }, { threshold: [0, 0.2] }).observe(closer);
  }

  /* ---- smooth scroll for the in-page jump ---- */
  $$('a[href^="#about-"]').forEach(function (a) {
    a.addEventListener("click", function (event) {
      var target = document.getElementById(a.getAttribute("href").slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
    });
  });
})();

/* copy deterrent (owner, 2026-10-04: "dont let folks copy/click on the pages so it's harder to control c"). Inside the brand
   sections: no text selection, no dragging or right-click menu on pictures and plain text, no copy. Form fields, help answers
   and links keep working (a right-click on a text link still offers "open in new tab"). It deters casual copying; it cannot
   stop someone reading the page source. */
(function () {
  "use strict";
  if (window.__tk9Guard) return;
  window.__tk9Guard = true;
  var ROOT = ".tkb, .tka, .tkh", OK = "input, textarea, select, [contenteditable], .tkh-answer, [data-copy-ok]";
  var el = function (n) { return n && n.nodeType === 1 ? n : n && n.parentElement; };
  var guarded = function (n) { n = el(n); return !!(n && n.closest(ROOT) && !n.closest(OK)); };
  document.addEventListener("contextmenu", function (e) {
    var n = el(e.target);
    if (!guarded(n)) return;
    var media = n.closest("img, video, picture, figure, [class*='-bit'], [class*='-cast'], [class*='-peek']");
    if (media || !n.closest("a[href], button")) e.preventDefault();
  });
  document.addEventListener("dragstart", function (e) { if (guarded(e.target)) e.preventDefault(); });
  document.addEventListener("selectstart", function (e) { if (guarded(e.target)) e.preventDefault(); });
  document.addEventListener("copy", function (e) { var s = window.getSelection && window.getSelection(); if (s && s.rangeCount && guarded(s.anchorNode)) e.preventDefault(); });
})();
